import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { CompanyDto, CompanyServiceProxy, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { DefaultSettingService } from '@shared/services/default-setting.service';

@Component({
  selector: 'app-select-company',
  templateUrl: './select-company.component.html',
  styleUrls: ['./select-company.component.css']
})

export class SelectCompanyComponent extends AppComponentBase implements OnInit {

  dataSource: CompanyDto[] = [];
  isDisabled: boolean = false;
  
  @Input() 
  showAll: Boolean = true;

  @Input()
  manuelDisabled: boolean = null;

  @Input()
  placeholder: string = this.l('Company');

  private _selection: number = 0;
  get selection(): number {
    return this._selection;
  }
  @Input()
  set selection(value: number) {
    if (this._selection === value) {
      return;
    }
    this._selection = value;
    this.selectionChange.emit(this._selection);
  }
  // @Input() selection: number;
  @Output() selectionChange = new EventEmitter<number>();
  
  constructor(injector: Injector,
    private _companyService: CompanyServiceProxy,
    private _userService: UserServiceProxy,
    private _defaultSettingsService: DefaultSettingService) {
    super(injector);
  }

  ngOnInit(): void {
    this._companyService.getCompanyList()
      .subscribe((result) => {
        this.dataSource = result;
      });

    this._userService.get(abp.session.userId).subscribe(result => {
      this.isDisabled = !result.isChangeCompany;
      if (this.manuelDisabled != null)
        this.isDisabled = this.manuelDisabled;
      if (!result.isChangeCompany){
        this.selection = result.companyId;
      } else {
        this.selection = this._defaultSettingsService.getCompanyId();
      }
    });
  }

  onSelectionChnaged(){
    this.selectionChange.emit(this.selection); 
  }
}
